import { Typography } from "@mui/material";

import BszReservationResult from "./BszReservationResult";

export default function BszReservationList({
  reservations,
  getRemainingMinutes,
  canShowTime,
}) {
  if (reservations.length === 0) {
    return (
      <Typography variant="body2" sx={{ opacity: 0.7 }}>
        ❌ Nicht vor Ort
      </Typography>
    );
  }

  return reservations.map((reservation, index) => (
    <BszReservationResult
      key={index}
      reservation={reservation}
      remaining={getRemainingMinutes(reservation.endTime)}
      showTime={canShowTime(reservation)}
    />
  ));
}
